import { useParams, Link } from "react-router-dom";
import { Product, products } from "../data/products";
import { useState, useEffect } from "react";
import RenderGallery from "components/ImageGallery";
import RevendeurCta from "components/RevendeurCta";
import SEOMeta from "components/SEOMeta";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import RelatedProducts from "components/RelatedProducts";
import { ProductSEO } from "components/ProductSEO";

export default function ProductDetail() {
  const { setItems } = useBreadcrumb();
  const { slug } = useParams<{ slug: string }>();
  const product: Product | undefined = products.find((p) => p.slug === slug);
  const [imageSrc, setImageSrc] = useState<string>(product?.images?.[0] ?? "");
  useEffect(() => {
    const first = product?.images?.[0] ?? "";
    setImageSrc(first);
  }, [product]);
  useEffect(() => {
    if (!product) return;
    setItems([
      { label: "Accueil", href: "/" },
      { label: "Produits", href: "/produits" },
      { label: product.name },
    ]);
  }, [product, setItems]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [slug]);

  if (!product) {
    return (
      <div>
        Produit introuvable. <Link to="/produits">Retour aux produits</Link>
      </div>
    );
  }

  const {
    name,
    images,
    short,
    specs,
    description,
    revendeurs,
    ficheTechnique,
  } = product;

  const productsRelatedTo = products.filter((p) => p.slug !== product.slug);

  return (
    <>
      <SEOMeta
        title={name}
        description={`Découvrez notre armoire ${name} avec système de sécurisé certifié pour la protection de vos fusils.`}
        ogType={"product"}
      />
      <ProductSEO product={product} productsRelatedTo={productsRelatedTo} />

      <section className="grid">
        <div
          className="card"
          style={{ minHeight: 240 }}
          aria-label="Image du produit"
        >
          <div>
            <img className="main-picture" src={imageSrc} alt={name} />
          </div>

          <RenderGallery
            images={images}
            onSelect={setImageSrc}
            current={imageSrc}
            name={name}
          />
        </div>
        <div className="product-desc">
          <h1>{name}</h1>
          <p className="color-product-desc">{short}</p>
          <hr />
          <h2>Caractéristiques</h2>
          <ul className="color-product-desc">
            {Object.entries(specs).map(([k, v]) => (
              <li key={k}>
                <strong>{k}:</strong> {String(v)}
              </li>
            ))}
          </ul>
          <hr />
          <RevendeurCta revendeurs={revendeurs} />
        </div>
      </section>
      <section style={{ marginTop: 16 }}>
        <h2>Description</h2>
        <p className="color-product-desc">{description}</p>
      </section>
      <section style={{ marginTop: 16 }}>
        <h2>Fiche Technique</h2>
        <p>
          <a href={ficheTechnique} target="_blank" rel="noreferrer noopener">
            Télécharger la fiche technique
          </a>
        </p>
      </section>
      <section style={{ marginTop: 32 }}>
        <RelatedProducts relatedProducts={productsRelatedTo} />
      </section>
    </>
  );
}
